import { useEffect, useState } from "react";
import Select from 'react-select';

interface TimePickerProps {
    time: string,
    disable?: boolean,
    onChange: (value) => void,
}

function TimePicker({ time, disable = false, onChange }: TimePickerProps) {

    const [times, setTimes] = useState([])

    useEffect(() => {
        let times = []

        for (let index = 0; index <=  23; index++) {
            let h = `${index}`.padStart(2, '0')
            times.push({ value: `${h}:00`, label: `${h}:00`})
            times.push({ value: `${h}:30`, label: `${h}:30`})
            
        }
        times.push({ value: `23:59`, label: `23:59`})

        setTimes(times)
    }, [])


    return (        
        <Select
            options={times}
            isMulti={false}
            className={'form-select-custom ' + (false ? ' is-invalid' : '')}
            classNamePrefix='form-select-custom'
            placeholder='Selecciona una hora'
            onChange={ (data: any) => onChange(`${data.value}:00`) }
            value={{ value: time.slice(0,5), label: time.slice(0,5) }}
            isDisabled={ disable }
        />
    )
}
export default TimePicker